import Feature from "ol/Feature";
import Geometry from "ol/geom/Geometry";
import Polygon from "ol/geom/Polygon";
import MultiPoint from "ol/geom/MultiPoint";
import MultiPolygon from "ol/geom/MultiPolygon";
import { Circle as CircleStyle, Fill, Stroke, Style, Text } from "ol/style";

import FeatureVariation from "lib/classes/featurevariation";
import RasterImage from "lib/classes/rasterimage";

import { getFeatureLabel, getFeatureVariation } from "lib/utilities/feature";

export default function StyleFeature(feature: Feature<Geometry>) {
	const variation: FeatureVariation = getFeatureVariation(
		feature.get("variation-id"),
		feature.get("interaction-name")
	);
	const rasterImage:RasterImage = feature.get("rasterimg");
	
	const isSketch: boolean = feature.get("sketch");
	const isDrawn: boolean = !!feature.get("origin");
	
	let styles:Style[] = [
		new Style({
			stroke: rasterImage?.getLocked() ? null : new Stroke({
				color: variation?.colorHex || "#00b1c8",
				width: 3,
			}),
			fill: new Fill({
				color: !feature.get("rasterimg") ? "rgba(255, 255, 255, 0.5)" : "rgba(255, 255, 255, 0)",
			}),
			image: new CircleStyle({
				radius: 6,
				fill: new Fill({
					color: variation?.colorHex || "#00b1c8",
				}),
				stroke: new Stroke({
					color: "black",
					width: 1,
				}),
			})
		})
	];
	
	const getTextStyle = (index:number = 0):Style => {
		const fontSize:number = Number(feature.get('FontSize')) || 14;
		let geometry = null;
		
		if(feature.getGeometry().getType() == "MultiPolygon")
			geometry = (feature: any) => feature.getGeometry().getInteriorPoints().getPoint(index);
		
		return new Style({
			text: new Text({
				font: `bold ${fontSize}px "Helvetica Neue", "Arial", san-serif`,
				textBaseline: "middle",
				backgroundFill: new Fill({
					color: "rgba(0,0,0,0.5)",
				}),
				fill: new Fill({
					color: "white",
				}),
				offsetY: isSketch || feature.get("type") == "point" ? -22 : 0,
				text: getFeatureLabel(feature, index),
				padding: [3, 2, 2, 2],
			}),
			geometry: geometry
		});
	}
	
	switch(feature.getGeometry().getType()) {
		case "MultiPolygon": {
			const multiPolygon:MultiPolygon = feature.getGeometry() as MultiPolygon;
			const polygons:Polygon[] = multiPolygon.getPolygons();
			
			for(let i = 0; i < polygons.length; i++)
				styles.push(getTextStyle(i));
				
			break;
		}
		default: {
			// Raster image feature needs no text
			if(feature.get("rasterimg")) break;
			
			styles.push(getTextStyle());
			break;
		}
	}
	
	return styles;
}
